module.exports = __webpack_public_path__ + "img/logo.22b98db.png";